import { cmxTypeguards, commonActions, loggerFactory } from '@codametrix/ui-common';
import { IS_PRODUCTION } from '../environment';
import { setIsActive } from '../net';
import store from '../../store/store';
const logger = loggerFactory('ParentWindowSubscriptions');
const activityEvents = new Set([
    `${commonActions.AuthenticatedWindow.ACTIVITY}`
]);
const isBroadcast = (item)=>{
    return (cmxTypeguards.isReduxAction(item) && item.meta?.broadcast) ?? false;
};
const senderSubscriptions = [
    {
        match: isBroadcast
    },
    {
        observe: (item)=>{
            isBroadcast(item) && console.log(`Broadcasting: ${item.type}`, item);
        }
    }
];
const ChildWindowActivityObserver = {
    observe: (item)=>{
        if (cmxTypeguards.isReduxAction(item)) {
            const suppressRedux = item.meta?.suppressRedux ?? false;
            if (suppressRedux) {
                if (activityEvents.has(item.type)) {
                    logger.log(`ChildWindowActivityObserver`, item);
                    setIsActive(true);
                }
            } else {
                //
                if (item.meta) {
                    item.meta.broadcast = false;
                }
                store.dispatch(item);
            }
            return false;
        }
    }
};
const receiverSubscriptions = [
    ChildWindowActivityObserver
];
if (!IS_PRODUCTION) {
    receiverSubscriptions.push({
        observe: (msg)=>{
            console.log(`message received`, msg);
        }
    });
}
export { senderSubscriptions, receiverSubscriptions };
